import React, { useMemo } from 'react';
import { AlertTriangle, X } from 'lucide-react';
import { Badge } from './ui/badge';
import JobCard from './JobCard';

const FILTER_LABELS = {
  delayed: 'Geciken Isler',
  critical: 'Kritik Isler',
};

const JobsTab = ({ activeJobs, activeDelayedJobs, activeNonDelayedJobs, completedJobs, can, jobCallbacks, filter, onClearFilter }) => {
  // Apply filter if set
  const filteredActiveJobs = useMemo(() => {
    if (!filter) return null;
    if (filter === 'delayed') return activeJobs.filter(j => j.isDelayed);
    if (filter === 'critical') return activeJobs.filter(j => j.delaySeverity === 'critical');
    return null;
  }, [filter, activeJobs]);

  const isFiltered = !!filter && filteredActiveJobs !== null;

  return (
    <div className="space-y-4" data-testid="tab-jobs">
      {/* Active filter indicator */}
      {isFiltered && (
        <div className="flex items-center gap-2 bg-red-900/20 border border-red-700/40 rounded-lg px-4 py-2.5" data-testid="active-filter-banner">
          <AlertTriangle className="h-4 w-4 text-red-400 shrink-0" />
          <span className="text-red-300 text-sm font-medium">Filtre:</span>
          <Badge className="bg-red-600 text-white text-xs cursor-pointer hover:bg-red-700 transition-colors flex items-center gap-1.5"
            onClick={onClearFilter} data-testid="clear-filter-badge">
            {FILTER_LABELS[filter] || filter}
            <X className="h-3 w-3" />
          </Badge>
          <span className="text-gray-400 text-xs ml-auto">{filteredActiveJobs.length} sonuc</span>
        </div>
      )}

      {isFiltered ? (
        /* Filtered view */
        <>
          <h3 className="text-sm font-semibold text-red-400 flex items-center gap-2">
            <AlertTriangle className="h-4 w-4" />{FILTER_LABELS[filter]} ({filteredActiveJobs.length})
          </h3>
          {filteredActiveJobs.length === 0
            ? <div className="text-center text-gray-400 py-6">Bu filtreye uygun is bulunmuyor</div>
            : <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-3">
                {filteredActiveJobs.map(j => <JobCard key={j.id} job={j} can={can} {...jobCallbacks} />)}
              </div>
          }
        </>
      ) : (
        /* Default unfiltered view */
        <>
          {activeDelayedJobs.length > 0 && (
            <>
              <h3 className="text-sm font-semibold text-red-400 flex items-center gap-2">
                <AlertTriangle className="h-4 w-4" />Geciken Isler ({activeDelayedJobs.length})
              </h3>
              <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-3">
                {activeDelayedJobs.map(j => <JobCard key={j.id} job={j} can={can} {...jobCallbacks} />)}
              </div>
            </>
          )}
          <h3 className="text-sm font-semibold text-white">Aktif Isler ({activeJobs.length})</h3>
          {activeJobs.length === 0
            ? <div className="text-center text-gray-400 py-6">Aktif is bulunmuyor</div>
            : <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-3">{activeNonDelayedJobs.map(j => <JobCard key={j.id} job={j} can={can} {...jobCallbacks} />)}</div>
          }
          <h3 className="text-sm font-semibold text-white mt-6">Tamamlanan Isler ({completedJobs.length})</h3>
          {completedJobs.length === 0
            ? <div className="text-center text-gray-400 py-6">Tamamlanmis is yok</div>
            : <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-3">{completedJobs.map(j => <JobCard key={j.id} job={j} can={can} {...jobCallbacks} />)}</div>
          }
        </>
      )}
    </div>
  );
};

export default JobsTab;
